/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, pool: NonNullable<unknown> }} Usage_Status_Headline_Pool_OnlyInputs */



/**
* | output |
* | --- |
* | "You've used {used} of your {pool} pool this billing period." |
*
* @param {Usage_Status_Headline_Pool_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_status_headline_pool_only = /** @type {((inputs: Usage_Status_Headline_Pool_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Status_Headline_Pool_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie haben in dieser Abrechnungsperiode ${i?.used} von Ihrem ${i?.pool} Pool verbraucht.`)
	return /** @type {LocalizedString} */ (`You've used ${i?.used} of your ${i?.pool} pool this billing period.`)
});